import { render, staticRenderFns } from "./SuporteInterativo.vue?vue&type=template&id=2163ba6b&"
import script from "./SuporteInterativo.vue?vue&type=script&lang=js&"
export * from "./SuporteInterativo.vue?vue&type=script&lang=js&"
import style0 from "./SuporteInterativo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports